import { AdvancedMarker, useMap } from '@vis.gl/react-google-maps';

import { Box, Flex, Text } from '@rover/kibble/core';
import { FONT_FAMILY } from '@rover/kibble/styles/Font';
// Loaded as a URL so SVGO's minified gradient ID can't collide with other inline SVGs.
import pumpkinPinUrl from '@rover/react-lib/src/images/search/halloween/pumpkin_pin.svg?url';
import type { LatLng } from '@rover/types/src/LatLng';

// Elevation/Low from the Halloween Figma file. Kibble's elevation variants are box-shadows, which
// would draw a rectangle; drop-shadow follows the pumpkin's outline.
const ELEVATION_LOW_COLOR = 'rgba(27, 31, 35, 0.24)';

type Props = {
  position: LatLng<number>;
  title?: string;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  zIndex?: number;
  content?: string;
  scale?: number;
};

const PumpkinMarker = ({
  position,
  title,
  onClick,
  onMouseEnter,
  onMouseLeave,
  zIndex,
  content,
  scale = 1,
}: Props): JSX.Element | null => {
  const map = useMap();

  if (!map) return null;

  return (
    <AdvancedMarker
      position={position}
      title={title}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      draggable={false}
      zIndex={zIndex}
    >
      <Box
        position="relative"
        width="24px"
        height="24px"
        sx={{
          transform: `scale(${scale})`,
          filter: `drop-shadow(0 1px 2px ${ELEVATION_LOW_COLOR})`,
        }}
      >
        <img alt="" src={pumpkinPinUrl} width="24" height="24" draggable={false} />
        {content && (
          <Flex
            position="absolute"
            top="0"
            left="0"
            width="100%"
            height="100%"
            alignItems="center"
            justifyContent="center"
          >
            <Text
              textColor="primary"
              textAlign="center"
              sx={{
                // Google Maps sets Roboto, whose tabular 1 pushes two-digit ranks off center.
                fontFamily: FONT_FAMILY,
                fontSize: '10px',
                fontWeight: '600',
                lineHeight: 1.25,
              }}
            >
              {content}
            </Text>
          </Flex>
        )}
      </Box>
    </AdvancedMarker>
  );
};

export default PumpkinMarker;
